
<div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
    <h3><i class="fa-solid fa-building me-2"></i>Abteilungen ({{totalEntries}})</h3>
</div>

<button type="button" class="btn btn-primary mb-3" [routerLink]="['/department/detail', 0]">Abteilung anlegen</button>

<pagination
        [hidden]="entries?.length === 0"
        [totalItems]="totalEntries"
        [itemsPerPage]="paginConfig.itemsPerPage"
        [(ngModel)]="paginConfig.page"
        (pageChanged)="listEntries($event)"
        [maxSize]="20"
        previousText="Letzte"
        nextText="Nächste"
/>

<div class="table-responsive">
    <table *ngIf="entries?.length > 0" class="table table-sm table-striped table-hover bg-white pointer">
        <thead>
        <tr>
            <th style="width: 250px" (click)="setOrder('name')">
                Name <i class="fas" *ngIf="predicate === 'name'" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
            </th>
            <th (click)="setOrder('lead')">
                Leitung <i class="fas" *ngIf="predicate === 'lead'" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
            </th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let entry of entries" [routerLink]="['/department/detail', entry.id]">
            <td>{{ entry.name }}</td>
            <td>{{ entry.lead }}</td>
        </tr>
        </tbody>
    </table>
</div>
